<!-- quote-preview-v4.component.html — thème violet (swap) -->

<div class="relative">
  <!-- 🟣 Backplate glow (dégradé violet→indigo) -->
  <div class="absolute inset-0 rounded-2xl pointer-events-none"
       [ngClass]="isDarkMode()
         ? 'translate-x-1 translate-y-1 bg-gradient-to-r from-indigo-600 to-purple-600 opacity-80'
         : 'bg-gradient-to-r from-purple-300 to-indigo-300 opacity-50 blur-[2px]'">
  </div>

  <!-- 🧊 Panneau principal (verre fumé) -->
  <div class="relative rounded-2xl border shadow-sm transition-all backdrop-blur-md overflow-hidden ring-2"
       [ngClass]="isDarkMode()
       ? 'bg-[#111827] border-white/10 ring-purple-500/30'
       : 'bg-white border-gray-200 ring-purple-500/20'">

    <!-- 🟣 Sticky header étendu (jusqu'au lien Alternatives) -->
    <div class="sticky top-0 z-20"
         [ngClass]="isDarkMode() ? 'bg-[#111827]' : 'bg-white'">
      <!-- Barre résumé (gradient, bord supérieur) -->
      <div class="rounded-t-2xl bg-gradient-to-r from-purple-600 to-indigo-600 text-white">
        <div class="flex items-center px-3 py-2 gap-2">
          <!-- Résumé: 1 USDC → ETH -->
          <div class="font-semibold text-sm truncate">
            {{ getSummaryLine() || '—' }}

          </div>

          <!-- Groupe à droite : Réseau + Fermer (poussés à l'extrémité) -->
          <div class="ml-auto flex items-center gap-2">
            <!-- Réseau : pill discrète, plus lisible -->
            <div class="inline-flex items-center gap-1.5 pl-1.5 pr-2 py-0.5 rounded-full
                        text-[11px] uppercase tracking-[.06em] font-medium ring-1"
                 [ngClass]="isDarkMode()
                   ? 'bg-white/10 ring-white/15 text-white'
                  : 'bg-white/80 ring-purple-500/20 text-gray-900'">
              <span *ngIf="networkIconUrl"
                    class="relative inline-flex items-center justify-center w-4.5 h-4.5 rounded-full bg-white">
                <img [src]="networkIconUrl" alt="" class="w-3 h-3 rounded-full object-contain" />

              </span>
              <span class="whitespace-nowrap">{{ networkName || 'Ethereum' }}</span>

            </div>

            <!-- Fermer -->
            <button type="button"
                    class="p-1 rounded-full hover:bg-white/10"
                    (click)="close.emit()">
              <svg class="w-4 h-4" viewBox="0 0 24 24" stroke="currentColor" fill="none">

                <line x1="18" y1="6" x2="6" y2="18" />

                <line x1="6" y1="6" x2="18" y2="18" />

              </svg>

            </button>

          </div>

        </div>
      </div>

      <!-- Corps du header (même fond que le panneau) -->
      <div class="px-4 md:px-5 bg-inherit"
           [ngClass]="showAlternatives ? 'pt-4 pb-1.5 md:pt-5 md:pb-2' : 'py-4 md:py-5'">
        <!-- ==== Header (provider + buy amount) ==== -->
        <div class="grid items-start gap-3"
             style="grid-template-columns:minmax(0,1fr) max-content;">
          <!-- Provider bloc -->
          <div class="flex items-center gap-2 min-w-0">
            <img *ngIf="providerLogo" [src]="providerLogo" [alt]="'ALT.PROVIDER_LOGO' | translate" class="w-7 h-7 rounded-full" />
            <div class="flex flex-col min-w-0">
              <div class="font-semibold truncate"
                   [attr.title]="quote?.bridgeName || quote?.BridgeName || quote?.providerName || ('LABEL.PROVIDER' | translate)">
                {{ providerName }}
              </div>
              <div class="mt-1.5 text-xs opacity-70">
                {{ exchangeRate }}
              </div>
            </div>
          </div>

          <!-- Amount received -->
          <div class="text-right leading-tight">
            <div class="text-lg md:text-2xl font-bold tracking-tight [font-variant-numeric:tabular-nums]">
              {{ estimatedReceived }}
            </div>
            <div class="text-[11px] opacity-70">
              {{ estimatedReceivedFiat }}
            </div>
          </div>
        </div>

        <!-- ==== Toolbar (Share / Details / Validate) ==== -->
        <div class="mt-3 flex items-center gap-1.5 flex-nowrap">
          <button type="button"
                  (click)="onShareClick()"
                  class="px-2.5 py-1 rounded-lg border text-[11px] sm:text-sm whitespace-nowrap shrink-0 shadow-sm transition
                         hover:ring-2 hover:ring-purple-500/30 inline-flex items-center gap-1.5"
                  [ngClass]="isDarkMode() ? 'border-purple-400/20' : 'border-purple-500/20'">
            {{ 'BUTTON.SHARE' | translate }}
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                 aria-hidden="true" focusable="false">
              <path d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5" />
              <path d="M7.5 7.5 12 3m0 0 4.5 4.5M12 3v12" />
            </svg>
          </button>

          <button type="button"
                  (click)="showMainDetails = !showMainDetails"
                  class="px-2.5 py-1 rounded-lg border text-[11px] sm:text-sm inline-flex items-center gap-1
                         whitespace-nowrap shrink-0 shadow-sm transition hover:ring-2 hover:ring-purple-500/30"
                  [ngClass]="isDarkMode() ? 'border-purple-400/20' : 'border-purple-500/20'"
                  [attr.aria-label]="'ARIA.TOGGLE_DETAILS' | translate"
                  [attr.aria-expanded]="showMainDetails">
            <span>{{ showMainDetails ? ('BUTTON.HIDE' | translate) : ('BUTTON.DETAILS' | translate) }}</span>
            <svg class="w-3 h-3 sm:w-3.5 sm:h-3.5 transition-transform"
                 [ngClass]="showMainDetails ? 'rotate-180' : ''"
                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M10 12a1 1 0 0 1-.7-.29l-4-4a1 1 0 1 1 1.4-1.42L10 9.59l3.3-3.3a1 1 0 1 1 1.4 1.42l-4 4A1 1 0 0 1 10 12z"
                    clip-rule="evenodd" />
            </svg>
          </button>

          <!-- ✅ CTA principal -->
          <ng-container *ngIf="getMainCtaState() as cta">
            <!-- conteneur relatif pour positionner l’overlay au-dessus du bouton -->
            <div class="relative ml-auto">
              <button type="button"
                      [disabled]="cta.disabled"
                      (click)="onMainCtaClick()"
                      class="ml-auto px-3 py-1.5 rounded-xl border font-semibold text-[11px] sm:text-sm
                   whitespace-nowrap shrink-0 shadow-sm transition
                   enabled:hover:shadow enabled:hover:ring-2 enabled:hover:ring-purple-500/30
                   disabled:opacity-40 disabled:cursor-not-allowed"
                      [ngClass]="isDarkMode()
              ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white border-white/10'
              : 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white border-purple-500/20'">
                {{ cta.label }}
              </button>
              <!-- ✅ Overlay qui capte le clic quand le bouton est disabled -->
              <div *ngIf="cta?.disabled"
                   class="absolute inset-0 z-[2600] cursor-not-allowed"
                   (click)="revealMainWhy()"
                   aria-hidden="true"></div>

            </div>
          </ng-container>
        </div>


        <!-- ===== MAIN status (sous les boutons) ===== -->
        <ng-container *ngIf="expandedAltIndex === null
                   && lastAltStatusIndex == null
                      && isMainActive()
                   && (swapStatus === 'approve'
                       || swapStatus === 'pending'
                       || swapStatus === 'success'
                       || swapStatus === 'cancelled'
                       || swapStatus === 'error')">
          <div class="mt-1.5 text-center text-[11px] sm:text-xs">
            <ng-container [ngSwitch]="swapStatus">
              <div *ngSwitchCase="'approve'" class="text-purple-600 dark:text-purple-300">
                {{ 'STATUS.APPROVING' | translate : {} : 'Approbation en cours…' }}

              </div>
              <div *ngSwitchCase="'pending'" class="text-purple-600 dark:text-purple-300">
                {{ 'STATUS.PENDING' | translate : {} : 'Transaction en cours…' }}

              </div>
              <div *ngSwitchCase="'success'" class="text-green-600 dark:text-green-400">
                {{ 'STATUS.SUCCESS' | translate : {} : 'Transaction confirmée' }}
                <a *ngIf="swapHash"
                   class="underline ml-1"
                   target="_blank" rel="noopener"
                   [href]="getExplorerTxUrl(pickChainIdForTx(quote), swapHash)">
                  #{{ swapHash | slice:0:6 }}…{{ swapHash | slice:-4 }}
                </a>
              </div>
              <div *ngSwitchCase="'cancelled'" class="text-gray-600 dark:text-gray-400">
                {{ 'STATUS.CANCELLED_BY_USER' | translate : {} : 'Transaction annulée par l’utilisateur' }}
              </div>
              <div *ngSwitchCase="'error'" class="text-rose-600 dark:text-rose-400">
                {{ getFormattedBridgeError(swapError) || ('STATUS.ERROR' | translate : {} : 'Erreur durant le swap.') }}
              </div>
            </ng-container>
          </div>
        </ng-container>

        <!-- ==== Why disabled (main) — aligné sur le CTA principal ==== -->
        <ng-container *ngIf="getMainCtaState() as cta">
          <div *ngIf="isWalletConnected() && cta.disabled && (cta.reasons?.length) && showWhyMain"
               class="mt-1 text-xs"
               [ngClass]="isDarkMode() ? 'text-amber-300' : 'text-amber-700'"
               aria-live="polite">
            {{ getMainFirstReasonLabel() }}

          </div>

        </ng-container>

        <!-- ==== Main details (SWAP) ==== -->
        <ng-container *ngIf="showMainDetails">
          <div class="mt-2">
            <div class="rounded-2xl px-3 py-2 md:py-3 border shadow-sm backdrop-blur-md"
                 [ngClass]="isDarkMode()
                   ? 'bg-[#0b1020]/70 border-white/10'
                   : 'bg-gray-50/90 border-gray-200'">
              <div class="grid gap-1 md:gap-2 md:grid-cols-2 text-[11px] sm:text-xs [font-variant-numeric:tabular-nums]">

                <!-- Min. garanti -->
                <div class="flex items-start justify-between leading-snug md:col-span-2">
                  <!-- conteneur relatif pour positionner le panneau -->
                  <span class="relative inline-flex items-center gap-1">
                    {{ 'MIN_GUARANTEED' | translate }}
                    <button type="button" (click)="toggleTooltip('slippage', $event)"
                            class="inline-flex items-center justify-center rounded-full cursor-pointer
      h-4 w-4 p-0 leading-none appearance-none select-none
      focus:outline-none focus-visible:ring-0 active:ring-0 ring-1 transition
      pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                            [ngClass]="isDarkMode()
                ? 'text-white/90 ring-white/30 hover:bg-white/10'
                : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                      <span class="text-[10px] font-semibold -mt-px">i</span>

                    </button>
                    <!-- Panneau tooltip -->
                    <div *ngIf="openedTooltip==='slippage'"
                         class="absolute z-50 left-0 -top-2 translate-y-[-100%] max-w-[260px]
              rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug
              backdrop-blur-md"
                         [ngClass]="isDarkMode()
         ? 'bg-[#0b1020]/90 border-white/10'
         : 'bg-white/95 border-gray-200'" (click)="$event.stopPropagation()">
                      <div class="opacity-80">
                        {{ 'TOOLTIP.MIN_GUARANTEED' | translate }}
                      </div>
                      <a class="mt-1 inline-block font-medium underline"
                         target="_blank" rel="noopener"
                         [href]="getHelpUrl('slippage')">
                        {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                      </a>
                    </div>
                  </span>

                  <span class="text-right leading-tight">
                    <span class="font-medium text-[11px] sm:text-sm">{{ getMinReceivedAmount() }} {{ buyTokenSymbol || quote?.buyTokenSymbol || '' }}</span>
                    <div class="opacity-70 text-[10px] sm:text-xs">(≈ {{ getMinReceivedFiat() }})</div>
                  </span>
                </div>

                <!-- Frais réseau -->
                <div class="flex items-start justify-between leading-snug md:col-span-2">
                  <span class="relative inline-flex items-center gap-1">
                    <!-- le libellé seul garde l’opacité -->
                    <span class="opacity-70">
                      {{ 'NETWORK_FEE' | translate }}
                    </span>

                    <!-- l’icône n’hérite plus de l’opacité -->
                    <button type="button" (click)="toggleTooltip('network_fees', $event)"
                            class="inline-flex items-center justify-center rounded-full cursor-pointer
h-4 w-4 p-0 leading-none appearance-none select-none
focus:outline-none focus-visible:ring-0 active:ring-0 ring-1 transition
pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                            [ngClass]="isDarkMode()
          ? 'text-white/90 ring-white/30 hover:bg-white/10'
          : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                      <span class="text-[10px] font-semibold -mt-px">i</span>

                    </button>

                    <!-- Tooltip identique -->
                    <div *ngIf="openedTooltip==='network_fees'"
                         class="absolute z-50 left-0 -top-2 translate-y-[-100%] max-w-[260px]
              rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                         [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'" (click)="$event.stopPropagation()">
                      <div class="opacity-80">
                        {{ 'TOOLTIP.NETWORK_FEE' | translate }}
                      </div>
                      <a class="mt-1 inline-block font-medium underline"
                         target="_blank" rel="noopener"
                         [href]="getHelpUrl('network_fees')">
                        {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                      </a>
                    </div>
                  </span>



                  <span class="text-right leading-tight">
                    <span class="font-medium text-[11px] sm:text-sm">{{ mainFee?.textEth || '—' }}</span>
                    <div *ngIf="mainFee?.textFiat" class="opacity-70 text-[10px] sm:text-xs">{{ mainFee.textFiat }}</div>
                  </span>
                </div>

                <!-- Impact prix -->
                <div class="flex items-start justify-between leading-snug">
                  <span class="relative inline-flex items-center gap-1">
                    {{ 'PRICE_IMPACT' | translate }}
                    <button type="button" (click)="toggleTooltip('price_impact', $event)"
                            class="inline-flex items-center justify-center rounded-full cursor-pointer
h-4 w-4 p-0 leading-none appearance-none select-none
focus:outline-none focus-visible:ring-0 active:ring-0 ring-1 transition
pointer-events-auto [-webkit-tap-highlight-color:transparent]"
                            [ngClass]="isDarkMode()
          ? 'text-white/90 ring-white/30 hover:bg-white/10'
          : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                      <span class="text-[10px] font-semibold -mt-px">i</span>

                    </button>
                    <div *ngIf="openedTooltip==='price_impact'"
                         class="absolute z-50 left-0 -top-2 translate-y-[-100%] max-w-[260px]
              rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                         [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'"
                         (click)="$event.stopPropagation()">
                      <div class="opacity-80">
                        {{ 'TOOLTIP.PRICE_IMPACT' | translate }}
                      </div>
                      <a class="mt-1 inline-block font-medium underline"
                         target="_blank" rel="noopener"
                         [href]="getHelpUrl('price_impact')">
                        {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                      </a>
                    </div>
                  </span>

                  <span class="font-medium text-[11px] sm:text-sm">{{ priceImpact }}</span>
                </div>

              </div>
            </div>
          </div>
        </ng-container>

        <!-- ==== Alternatives header (bouton plié/déplié) ==== -->
        <div *ngIf="otherRoutes?.length" class="mt-2">
          <button type="button"
                  (click)="toggleAlternatives()"
                  class="px-2.5 py-1 rounded-lg border text-[11px] sm:text-sm shadow-sm inline-flex items-center gap-1.5 transition
                         hover:ring-2 hover:ring-purple-500/30"
                  [ngClass]="isDarkMode()
                    ? 'border-purple-400/20'
                    : 'border-purple-500/20'"
                  [attr.aria-label]="'ARIA.TOGGLE_ALTERNATIVES' | translate"
                  [attr.aria-expanded]="showAlternatives">
            <span>
              {{
                showAlternatives
                  ? ('ALTERNATIVES.HIDE' | translate)
                  : ('ALTERNATIVES.COUNT' | translate:{ count: otherRoutes.length })
              }}
            </span>
            <svg class="w-3 h-3 sm:w-3.5 sm:h-3.5 transition-transform"
                 [ngClass]="showAlternatives ? 'rotate-180' : ''"
                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M10 12a1 1 0 0 1-.7-.29l-4-4a1 1 0 1 1 1.4-1.42L10 9.59l3.3-3.3a1 1 0 1 1 1.4 1.42l-4 4A1 1 0 0 1 10 12z"
                    clip-rule="evenodd" />
            </svg>
          </button>
        </div>
      </div> <!-- /corps header étendu -->
    </div> <!-- /sticky header étendu -->
    <!-- ===== Zone scrollable : Alternatives list + sticky footer ===== -->
    <div #scrollArea
         class="px-4 md:px-5 overflow-y-auto max-h-[calc(100svh-256px)]"
         [ngClass]="(isDarkMode() ? 'bg-[#111827]' : 'bg-white') + ' ' + (showStickyFooter ? 'pb-0' : 'pb-4 md:pb-5')">


      <!-- ==== Alternatives list (affiché seulement si déplié) ==== -->
      <div class="mt-1.5 space-y-1.5" *ngIf="otherRoutes?.length && showAlternatives">
        <div *ngFor="let r of otherRoutes; let i = index">
          <ng-container *ngIf="expandedAltIndex === null || expandedAltIndex === i">
            <div class="rounded-xl border p-3 shadow-sm"
                 [ngClass]="isDarkMode()
           ? 'bg-[#1e1e2f]/70 border-purple-400/10'
           : 'bg-white/70 border-purple-500/10'"
                 data-alt-card>

              <!-- Row: provider left / amounts right (ALTERNATIVE) -->
              <div class="grid items-center gap-2" style="grid-template-columns:minmax(0,1fr) max-content;">
                <div class="flex items-center gap-1.5 min-w-0">
                  <img *ngIf="getRouteLogo(r)" [src]="getRouteLogo(r)"
                       class="w-4 h-4 rounded-full" [alt]="'ALT.PROVIDER_LOGO' | translate" />
                  <div class="truncate font-medium text-[11px] sm:text-[12px] md:text-sm"
                       [attr.title]="getRouteProvider(r)">
                    {{ getRouteProvider(r) }}
                  </div>

                  <span class="ml-1 inline-flex items-center gap-1 rounded-full px-1 py-0.5 ring-1"
                        [ngClass]="{
                      'bg-green-500/15 ring-green-400/20' : gasLevel(r)==='ok',
                      'bg-amber-500/15 ring-amber-400/20' : gasLevel(r)==='mid',
                      'bg-red-500/15 ring-red-400/20'     : gasLevel(r)==='high'
                    }"
                        [attr.title]="gasLevel(r)==='ok' ? ('TOOLTIP.GAS_OK'|translate)
                                   : gasLevel(r)==='mid' ? ('TOOLTIP.GAS_MED'|translate)
                                   : ('TOOLTIP.GAS_HIGH'|translate)"
                        [attr.aria-label]="gasLevel(r)==='ok' ? ('TOOLTIP.GAS_OK'|translate)
                                   : gasLevel(r)==='mid' ? ('TOOLTIP.GAS_MED'|translate)
                                   : ('TOOLTIP.GAS_HIGH'|translate)">
                    <svg viewBox="0 0 24 24" class="h-3.5 w-3.5">
                      <path d="M3 13a9 9 0 0 1 18 0" fill="none" stroke="currentColor" stroke-width="2" opacity="0.35" />
                      <g [ngClass]="{
                        'text-green-500' : gasLevel(r)==='ok',
                        'text-amber-500' : gasLevel(r)==='mid',
                        'text-red-500'   : gasLevel(r)==='high'
                      }">
                        <path d="M12 12 L18 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                              [ngClass]="{
                            'rotate-[-45deg]' : gasLevel(r)==='ok',
                            'rotate-0'        : gasLevel(r)==='mid',
                            'rotate-[45deg]'  : gasLevel(r)==='high'
                          }" />
                        <circle cx="12" cy="12" r="1.7" fill="currentColor"></circle>
                      </g>
                    </svg>

                    <span class="hidden md:inline text-[10px] font-medium"
                          [ngClass]="{
                        'text-green-700 dark:text-green-300' : gasLevel(r)==='ok',
                        'text-amber-700 dark:text-amber-300' : gasLevel(r)==='mid',
                        'text-red-700 dark:text-red-300'     : gasLevel(r)==='high'
                      }">
                      {{
                    gasLevel(r)==='ok' ? ('BADGE.GAS_OK'|translate)
                      : gasLevel(r)==='mid' ? ('BADGE.GAS_MED'|translate)
                      : ('BADGE.GAS_HIGH'|translate)
                      }}
                    </span>
                  </span>
                </div>

                <div class="text-right leading-tight">
                  <div class="text-sm md:text-base font-semibold [font-variant-numeric:tabular-nums]">
                    {{ getRouteEstimatedBuy(r) }}
                  </div>
                  <div class="text-[10px] opacity-70">
                    {{ getRouteEstimatedBuyFiat(r) }}
                  </div>
                </div>
              </div>

              <!-- Subline: rate + details toggle -->
              <div class="mt-1.5 flex items-center gap-2 text-xs opacity-70 min-w-0">
                <div class="flex-1 min-w-0 truncate">{{ getRateText(r) }}</div>

                <!-- Détails caché quand l’ALT i est ouverte -->
                <button *ngIf="expandedAltIndex !== i"
                        type="button"
                        (click)="toggleAlt(i)"
                        [attr.aria-label]="'ARIA.TOGGLE_ALT_DETAILS' | translate"
                        aria-expanded="false"
                        class="group inline-flex items-center rounded-full p-[1px] shadow-sm transition active:scale-[0.99]
                  bg-gradient-to-r from-purple-500 to-indigo-600
                  whitespace-nowrap shrink-0">
                  <span class="inline-flex items-center gap-1 rounded-full
                  px-2 py-1 min-h-[28px] text-[11px] font-semibold
                  ring-1 ring-white/10 group-hover:ring-white/20 text-white
                  md:gap-1.5 md:px-3 md:py-1.5 md:min-h-[30px] md:text-[12px]">

                    <span>{{ 'BUTTON.DETAILS' | translate }}</span>
                    <span class="inline-flex h-3.5 w-3.5 items-center justify-center rounded-full
                    bg-white/15 ring-1 ring-white/15 transition
                    group-hover:bg-white/20
                    md:h-4 md:w-4">
                      <svg viewBox="0 0 24 24" fill="none"
                           class="h-2.5 w-2.5 md:h-3 md:w-3"
                           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">

                        <path d="M6 9l6 6 6-6" />

                      </svg>
                    </span>
                  </span>
                </button>
              </div>


              <!-- Alt details (SWAP) — card-separated, hidden when collapsed -->
              <ng-container *ngIf="expandedAltIndex === i">
                <div class="mt-1.5">
                  <div class="rounded-2xl px-3 py-2 md:py-3 border shadow-sm backdrop-blur-md"
                       [ngClass]="isDarkMode()
                     ? 'bg-[#0b1020]/70 border-white/10'
                     : 'bg-gray-50/90 border-gray-200'">

                    <div class="grid gap-y-1.5 sm:gap-2 md:grid-cols-2 text-[11px] sm:text-xs [font-variant-numeric:tabular-nums]">

                      <!-- Impact prix -->
                      <div class="grid grid-cols-[1fr_auto] items-start gap-2.5 min-w-0 leading-snug">
                        <span class="relative inline-flex items-center gap-1 min-w-0">
                          <!-- libellé avec opacité -->
                          <span class="opacity-70 truncate">{{ 'PRICE_IMPACT' | translate }}</span>
                          <button type="button" (click)="toggleTooltip('price_impact','alt-'+i,$event)"
                                  class="inline-flex h-4 w-4 items-center justify-center rounded-full p-0 leading-none
              ring-1 transition pointer-events-auto focus:outline-none"
                                  [ngClass]="isDarkMode()
                ? 'text-white/90 ring-white/30 hover:bg-white/10'
                : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                            <span class="text-[10px] font-semibold -mt-px">i</span>
                          </button>

                          <!-- panneau tooltip -->
                          <div *ngIf="openedTooltip==='price_impact:alt-'+i"
                               class="absolute left-0 top-full mt-2 z-[2600] max-w-[260px]
             rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                               [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'">
                            <div class="opacity-80">{{ 'TOOLTIP.PRICE_IMPACT' | translate }}</div>
                            <a class="mt-1 inline-block font-medium underline"
                               target="_blank" rel="noopener"
                               [href]="getHelpUrl('price_impact')">
                              {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                            </a>
                          </div>
                        </span>

                        <span class="font-medium text-[11px] sm:text-sm whitespace-nowrap shrink-0 text-right">
                          {{ getRoutePriceImpact(r) }}
                        </span>
                      </div>


                      <!-- Min. garanti -->
                      <div class="grid grid-cols-[1fr_auto] items-start gap-2.5 min-w-0 md:col-span-2 leading-snug">
                        <span class="relative inline-flex items-center gap-1 min-w-0">
                          <span class="opacity-70 truncate">{{ 'MIN_GUARANTEED' | translate }}</span>


                          <button type="button" (click)="toggleTooltip('slippage','alt-'+i,$event)"
                                  class="inline-flex h-4 w-4 items-center justify-center rounded-full p-0 leading-none
ring-1 transition pointer-events-auto focus:outline-none"
                                  [ngClass]="isDarkMode()
  ? 'text-white/90 ring-white/30 hover:bg-white/10'
  : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                            <span class="text-[10px] font-semibold -mt-px">i</span>
                          </button>
                          <div *ngIf="openedTooltip==='slippage:alt-'+i"
                               class="absolute left-0 top-full mt-2 z-[2600] max-w-[260px]
             rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                               [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'">
                            <div class="opacity-80">{{ 'TOOLTIP.MIN_GUARANTEED' | translate }}</div>
                            <a class="mt-1 inline-block font-medium underline"
                               target="_blank" rel="noopener"
                               [href]="getHelpUrl('slippage')">
                              {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                            </a>
                          </div>
                        </span>

                        <span class="text-right leading-tight whitespace-nowrap shrink-0">
                          <span class="font-medium text-[11px] sm:text-sm">
                            {{ getRouteMinReceivedAmount(r) }} {{ getRouteBuySymbol(r) }}
                          </span>
                          <div class="opacity-70 text-[10px] sm:text-xs block">(≈ {{ getRouteMinReceivedFiat(r) }})</div>
                        </span>
                      </div>


                      <!-- Frais réseau -->
                      <div class="grid grid-cols-[1fr_auto] items-start gap-2.5 min-w-0 md:col-span-2 leading-snug">
                        <span class="relative inline-flex items-center gap-1 min-w-0">
                          <span class="opacity-70 truncate">{{ 'NETWORK_FEE' | translate }}</span>

                          <button type="button" (click)="toggleTooltip('network_fees','alt-'+i,$event)"
                                  class="inline-flex h-4 w-4 items-center justify-center rounded-full p-0 leading-none
ring-1 transition pointer-events-auto focus:outline-none"
                                  [ngClass]="isDarkMode()
  ? 'text-white/90 ring-white/30 hover:bg-white/10'
  : 'text-gray-700 ring-black/10 hover:bg-black/5'">
                            <span class="text-[10px] font-semibold -mt-px">i</span>
                          </button>
                          <div *ngIf="openedTooltip==='network_fees:alt-'+i"
                               class="absolute left-0 top-full mt-2 z-[2600] max-w-[260px]
             rounded-xl border shadow-lg p-2 text-[11px] sm:text-xs leading-snug backdrop-blur-md"
                               [ngClass]="isDarkMode() ? 'bg-[#0b1020]/90 border-white/10' : 'bg-white/95 border-gray-200'">
                            <div class="opacity-80">{{ 'TOOLTIP.NETWORK_FEE' | translate }}</div>
                            <a class="mt-1 inline-block font-medium underline"
                               target="_blank" rel="noopener"
                               [href]="getHelpUrl('network_fees')">
                              {{ 'TOOLTIP.LEARN_MORE' | translate : {} : 'En savoir plus' }}
                            </a>
                          </div>
                        </span>

                        <span class="text-right leading-tight whitespace-nowrap shrink-0">
                          <span class="font-medium text-[11px] sm:text-sm">{{ getRouteDisplayedGasFee(r).textEth }}</span>
                          <div *ngIf="getRouteDisplayedGasFee(r).textFiat" class="opacity-70 text-[10px] sm:text-xs">
                            {{ getRouteDisplayedGasFee(r).textFiat }}
                          </div>
                        </span>
                      </div>


                      <!-- ===== Bloc statut (au-dessus des CTA) — affiché seulement pour CETTE alternative ===== -->
                      <ng-container *ngIf="lastAltStatusIndex === i
                                    && isAltActive(r)
       && (swapStatus === 'approve'
           || swapStatus === 'pending'
           || swapStatus === 'success'
           || swapStatus === 'cancelled'
           || swapStatus === 'error')">
                        <div class="md:col-span-2 mt-1 text-center text-[11px] sm:text-xs">
                          <ng-container [ngSwitch]="swapStatus">
                            <!-- Approve / Pending -->
                            <div *ngSwitchCase="'approve'" class="text-purple-600 dark:text-purple-300">
                              {{ 'STATUS.APPROVING' | translate : {} : 'Approbation en cours…' }}

                            </div>
                            <div *ngSwitchCase="'pending'" class="text-purple-600 dark:text-purple-300">
                              {{ 'STATUS.PENDING' | translate : {} : 'Transaction en cours…' }}

                            </div>
                            <!-- Success -->
                            <div *ngSwitchCase="'success'" class="text-green-600 dark:text-green-400">
                              {{ 'STATUS.SUCCESS' | translate : {} : 'Transaction confirmée' }}
                              <a *ngIf="swapHash"
                                 class="underline ml-1"
                                 target="_blank" rel="noopener"
                                 [href]="getExplorerTxUrl(pickChainIdForTx(r), swapHash)">
                                #{{ swapHash | slice:0:6 }}…{{ swapHash | slice:-4 }}

                              </a>

                            </div>
                            <!-- Cancelled -->
                            <div *ngSwitchCase="'cancelled'" class="text-gray-600 dark:text-gray-400">
                              {{ 'STATUS.CANCELLED_BY_USER' | translate : {} : 'Transaction annulée par l’utilisateur' }}

                            </div>
                            <!-- Error (toujours formatée, jamais brute) -->
                            <div *ngSwitchCase="'error'" class="text-rose-600 dark:text-rose-400">
                              {{ getFormattedBridgeError(swapError) || ('STATUS.ERROR' | translate : {} : 'Erreur durant le swap.') }}

                            </div>

                          </ng-container>

                        </div>

                      </ng-container>
                      <!-- Why disabled (ALT i) -->
                      <div *ngIf="showWhyAlt[i] && (getAltCtaState(r)?.disabled) && (getAltReasons(r)?.length)"
                           class="mt-1 text-[11px] sm:text-xs"
                           [ngClass]="isDarkMode() ? 'text-amber-300' : 'text-amber-700'"
                           aria-live="polite">
                        {{ getAltFirstReasonLabel(r) }}

                      </div>
                      <!-- CTA row: Fermer + Valider (ALT ouverte, style violet aligné à droite) -->
                      <div class="mt-2 md:col-span-2 flex items-center justify-end gap-2">
                        <!-- Fermer (même style violet que Valider) -->
                        <button type="button"
                                (click)="toggleAlt(i)"
                                class="px-3 py-1.5 rounded-xl border font-semibold text-[11px] sm:text-sm shadow-sm transition
                           enabled:hover:shadow enabled:hover:ring-2 enabled:hover:ring-purple-500/30
                           disabled:opacity-40 disabled:cursor-not-allowed"
                                [ngClass]="isDarkMode()
                      ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white border-white/10'
                      : 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white border-purple-500/20'">
                          {{ 'BUTTON.CLOSE' | translate }}

                        </button>

                        <!-- Valider + overlay WHY (ALT) -->
                        <div class="relative">
                          <button type="button"
                                  [disabled]="getAltCtaState(r).disabled"
                                  (click)="onAltCtaClick(r,i)"
                                  class="px-3 py-1.5 rounded-xl border font-semibold text-[11px] sm:text-sm shadow-sm transition
                            enabled:hover:shadow enabled:hover:ring-2 enabled:hover:ring-purple-500/30
                             disabled:opacity-40 disabled:cursor-not-allowed"
                                  [ngClass]="isDarkMode()
                        ? 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white border-white/10'
                        : 'bg-gradient-to-r from-purple-600 to-indigo-600 text-white border-purple-500/20'">
                            {{ getAltCtaState(r).label }}

                          </button>
                          <!-- Overlay pour afficher WHY 4s si disabled (scopé au bouton Valider) -->
                          <div *ngIf="getAltCtaState(r).disabled"
                               class="absolute inset-0 z-[2600] cursor-not-allowed"
                               (click)="revealAltWhy(i, r)"
                               aria-hidden="true"></div>

                        </div>

                      </div>








                    </div>
                  </div>
                </div>
              </ng-container>

            </div>
          </ng-container>
        </div>
      </div> <!-- /Alternatives list -->
      <!-- Footer sticky (uniquement si déplié ET ça déborde) -->
      <div *ngIf="showStickyFooter"
           class="sticky bottom-0 z-20 mt-3 -mx-4 md:-mx-5 px-4 md:px-5 pt-3 pb-5 rounded-b-2xl"
           [ngClass]="isDarkMode()
       ? 'bg-[#111827] border-t border-white/10'
       : 'bg-white border-t border-gray-200'">


        <button type="button" (click)="closePreview()
          "
                class="w-full inline-flex items-center justify-center rounded-2xl px-4 py-2.5
                       text-sm font-semibold text-white shadow-sm transition active:scale-[0.99]
                       focus:outline-none focus:ring-2 focus:ring-purple-400/40
                       bg-gradient-to-r from-fuchsia-600 via-purple-600 to-indigo-600
                       hover:from-fuchsia-500 hover:via-purple-500 hover:to-indigo-500
                       border border-white/10
                       drop-shadow-[0_6px_20px_rgba(147,51,234,0.25)]">
          {{ 'COMMON.CLOSE' | translate }}
        </button>
      </div>

      <!-- Footer statique quand tout est plié -->
      <div *ngIf="!showStickyFooter"
           class="mt-4">
        <button type="button" (click)="closePreview()"
                class="w-full inline-flex items-center justify-center rounded-2xl px-4 py-2.5
                       text-sm font-semibold text-white shadow-sm transition active:scale-[0.99]
                       focus:outline-none focus:ring-2 focus:ring-purple-400/40
                       bg-gradient-to-r from-fuchsia-600 via-purple-600 to-indigo-600
                       hover:from-fuchsia-500 hover:via-purple-500 hover:to-indigo-500
                       border border-white/10
                       drop-shadow-[0_6px_20px_rgba(147,51,234,0.25)]">
          {{ 'COMMON.CLOSE' | translate }}
        </button>
      </div>

    </div> <!-- /#scrollArea -->
  </div> <!-- /panel -->
</div>
